import styles from '../../../styles/time-tracking.module.scss';
import TextField from '../../../components/TextField/TextField';
import Button from '../../../components/Button/Button';
import { EmployeeSelectionDropdown } from '../../../components/EmployeeSelectionDropdown/EmployeeSelectionDropdown';
import { roleCheckerOtherEmployee } from '../../../utils/roleCheckerOtherEmployee';

import { TimeTrackingHeaderBlockProps } from './types';
import { FC } from 'react';
import { useTimeTrackingHeaderBlock } from './useTimeTrackingHeaderBlock';

const TimeTrackingHeaderBlock: FC<TimeTrackingHeaderBlockProps> = ({
  currentDate,
  getTimeLogsList,
  setHandleValues,
}) => {
  const { t, onClickHandler, dateValue, isButtonDisabled } =
    useTimeTrackingHeaderBlock({
      currentDate,
      getTimeLogsList,
      setHandleValues,
    });

  const isManager = roleCheckerOtherEmployee();

  return (
    <div className={styles.formFooterEnd}>
      {isManager && (
        <EmployeeSelectionDropdown
          onEmployeeChange={() => {
            // The useEffect in useTimeTrackingPage will automatically refetch
            // when selectedEmployee?.id changes, so we don't need to do anything here
          }}
          setHandleValues={setHandleValues}
        />
      )}
      <TextField
        labelclassname={styles.labelEmpty}
        className={styles.datePickerInput}
        value={dateValue}
        readOnly
      />
      <Button
        label={t('buttons.today') as string}
        styleClass='btn__rounded-blue'
        onClick={onClickHandler}
        disabled={isButtonDisabled}
      />
    </div>
  );
};

export default TimeTrackingHeaderBlock;
